<form nz-form style="padding-top:12px;padding-right:12px"   autocomplete="off">
  <div nz-row [nzGutter]="['24','24']">
      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="folkCode" nzRequired>Tiêu đề</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input   [(ngModel)]="announce.title" [ngModelOptions]="{standalone: true}" type="text" placeholder="Nhập tiêu đề" [jAutofocus]>
        </nz-form-control>
        </nz-form-item >
      </div>

      <div nz-col nzSm="12" nzMd="12">
        <nz-form-item>
          <nz-form-label nzSpan="24" >Ngày bắt đầu</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-date-picker [(ngModel)]="announce.startDate" [ngModelOptions]="{standalone: true}" [nzFormat]="'dd/MM/yyyy'"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSm="12" nzMd="12">
        <nz-form-item>
          <nz-form-label nzSpan="24" >Ngày hết hạn</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-date-picker [(ngModel)]="announce.expirationDate" [ngModelOptions]="{standalone: true}" [nzFormat]="'dd/MM/yyyy'"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </div>
  
      <div nz-col nzSm="12" nzMd="12">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzRequired>Đối tượng:</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-radio-group [(ngModel)]="announce.announceType" [ngModelOptions]="{standalone: true}">
              <label nz-radio   [nzValue]="1" *ngIf="currentUser.accountType == 6 || currentUser.accountType == 5">đơn vị quản lý cấp Tỉnh/thành phố</label>
              <label nz-radio [nzValue]="2" *ngIf="(currentUser.accountType == 6 || currentUser.accountType == 5 || currentUser.accountType == 1)">Cơ sở</label>
              <label nz-radio [nzValue]="3">Nhân sự</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>
  
      <div nz-col nzSm="12" nzMd="12">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzRequired>Phạm vi:</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-radio-group [(ngModel)]="announce.isCustom" [ngModelOptions]="{standalone: true}"> 
              <label nz-radio [nzValue]="false">Tất cả</label>
              <label nz-radio [nzValue]="true">Tùy chọn</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSpan="24" *ngIf="announce.announceType == 1 && announce.isCustom == true">
        <nz-form-item>
          <nz-form-label nzSpan="24">Đơn vị trực thuộc</nz-form-label>
          <nz-select nzMode="tags" nzPlaceHolder="Chọn đơn vị trực thuộc" [(ngModel)]="listSubordinateTypeSelect"
            [ngModelOptions]="{standalone: true}">
            <nz-option *ngFor="let option of listDVQL" [nzLabel]="option.educationAndTrainingName" [nzValue]="option.id">
            </nz-option>
          </nz-select>
        </nz-form-item>
      </div>

      <div nz-col nzSpan="24" *ngIf="announce.announceType == 2 && announce.isCustom == true">
        <nz-form-item>
          <nz-form-label nzSpan="24">Cơ sở</nz-form-label>
          <nz-select nzMode="tags"  nzPlaceHolder="Chọn cơ sở" [(ngModel)]="listCosoSelect"
            [ngModelOptions]="{standalone: true}">
            <nz-option *ngFor="let option of listCoso" [nzLabel]="option.educationAndTrainingName" [nzValue]="option.id">
            </nz-option>
          </nz-select>
        </nz-form-item>
      </div>

      <div nz-col nzSpan="24" *ngIf="announce.announceType == 3 && announce.isCustom == true">
        <nz-form-item>
          <nz-form-label nzSpan="24">Nhân sự</nz-form-label>
          <nz-select nzMode="tags" nzPlaceHolder="Chọn nhân sự" [(ngModel)]="listStaffSelect"
            [ngModelOptions]="{standalone: true}">
            <nz-option *ngFor="let option of listStaff" [nzLabel]="option.fullName" [nzValue]="option.id">
            </nz-option>
          </nz-select>
        </nz-form-item>
      </div>

      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="body" nzRequired>Nội dung</nz-form-label>
          <nz-form-control nzSpan="24">
            <editor
            [(ngModel)]="announce.content" [ngModelOptions]="{standalone: true}"
              apiKey="m4incqi12031wyw9523nezwwksx8zg0mnvni6mnu03iovjeh"
              [init]="{
                language: 'vi',
                language_url : 'assets/tinymce_languages/vi.js',
                height: 300,
                menubar: 'file edit format table help',
                plugins: [
                  'advlist autolink lists link image charmap print',
                  'preview anchor searchreplace visualblocks code',
                  'fullscreen insertdatetime media table paste',
                  'help wordcount'
                ],
                toolbar:
                  'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media pageembed template link anchor codesample | a11ycheck ltr rtl | showcomments addcomment'
              }"
            >
            </editor>
          </nz-form-control>
        </nz-form-item >
      </div>

      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="listAttachment">Đính kèm</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-upload [(nzFileList)]="fileList"  [nzBeforeUpload]="beforeUpload"  [nzRemove]="hanldeRemove"  [nzShowUploadList]="{ showRemoveIcon: true, showDownloadIcon : false }">
              <button nz-button  ><i nz-icon nzType="upload"></i>Chọn File</button> 
            </nz-upload>
        </nz-form-control>
        </nz-form-item >
      </div>

  </div>
  <div *nzModalFooter>
    <div *ngIf="!isEditMode" class="card-footer text-right" >
      <popup-btn-footer [isDisableUpdate]="false" [isUpdateAndClose]="true" (updateAndClose)="UpdateClose()" (close)="close()"></popup-btn-footer>
    </div>
    <div *ngIf="isEditMode" class="card-footer text-right">
        <popup-btn-footer [isDisableUpdate]="false" [isUpdateAndClose]="true" (updateAndClose)="UpdateClose()" (close)="close()"></popup-btn-footer>
    </div>
  </div>
</form>